// extracted by mini-css-extract-plugin
module.exports = {"h3":"OppositeElement_h3__Z_lVy","wrapper":"OppositeElement_wrapper___6n_A","arrowsDiv":"OppositeElement_arrowsDiv__It04P"};